<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <v-card
          class="bar-header"
          :style="{
            background: setBackgoundBox(),
            borderRadius: setBorderRadiusBox(),
          }"
        >
          <v-container>
            <v-btn
              v-if="!inBottomNavbar"
              icon
              color="white"
              style="margin-top: 14px; margin-left: 2px; z-index: 2"
              elevation="2"
              @click="redirectTo"
            >
              <v-icon large>mdi-chevron-left-circle</v-icon>
            </v-btn>

            <v-card-text class="text-center mt-2">
              <span
                v-if="
                  !customHeader.isUseCustomHeader ||
                  (customHeader.isUseCustomHeader && customHeader.isUseTitle)
                "
                class="text-h6 white--text text-center"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  font-weight: 600;
                "
                :style="{
                  color: this.customHeader.titleColor,
                  'text-shadow': checkTitleShadow(),
                }"
              >
                {{ $t(statusTextMission) }}
              </span>
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" style="margin-top: -65px">
      <v-col cols="11" sm="8" md="8">
        <statusMissionBtnVue
          :statusMission="statusMission"
          :site="site"
          :status="+mission_status"
          @gotoMissionFilter="gotoMissionFilter"
        />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" class="pa-0">
        <v-sheet
          class="mx-auto"
          max-width="700"
          style="background-color: transparent"
        >
          <v-slide-group class="py-0" center-active mandatory show-arrows>
            <!-- Slot ปุ่มกดฝั่งซ้าย (Prev) -->
            <template v-slot:prev="{ on, attrs }">
              <v-btn
                icon
                fab
                x-small
                v-bind="attrs"
                v-on="on"
                class="custom-slide-btn"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </template>

            <!-- Slot ปุ่มกดฝั่งขวา (Next) -->
            <template v-slot:next="{ on, attrs }">
              <v-btn
                icon
                fab
                x-small
                v-bind="attrs"
                v-on="on"
                class="custom-slide-btn"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>

            <v-slide-item
              v-for="cate in category"
              :key="cate.id"
              v-slot="{ active, toggle }"
              @change="initialize(cate)"
            >
              <v-card
                rounded="lg"
                class="px-2 mx-1"
                @click="toggle"
                elevation="0"
                max-width="120"
                min-width="80"
                :style="
                  active
                    ? { border: '1.5px solid', 'border-color': site.color }
                    : ''
                "
              >
                <v-container class="pa-0">
                  <v-col class="d-flex justify-center pt-2 pb-0">
                    <v-icon :color="site.color">{{
                      `mdi-${cate.icon}`
                    }}</v-icon>
                  </v-col>
                  <p style="font-size: 12px" class="text-center mb-0">
                    {{ setTextCategory(cate) }}
                  </p>
                </v-container>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
      </v-col>
    </v-row>

    <listMissionVertical
      v-if="showList"
      :dataItems="dataItems"
      :site="site"
      class="mt-6"
      :status="mission_status"
      @view="updateViewType"
    ></listMissionVertical>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <div v-if="!dataItems.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <div
      class="fab-container"
      :style="{
        'padding-bottom': showBottomNavbar ? '70px' : '0px',
      }"
    >
      <v-btn
        v-show="site.is_scan"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="openDialogScan()"
      >
        <v-icon>mdi-qrcode-scan</v-icon>
      </v-btn>
      <v-btn
        v-if="checkFloatPanel"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="dialogFloatPanel = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>

    <DialogScan
      :dialogScan="dialogScan"
      @closeDialogScan="dialogScan = false"
      @onScanSuccess="handleScanSuccess"
    />

    <FloatPanel
      :dialog="dialogFloatPanel"
      @onClose="dialogFloatPanel = false"
    />
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import listMissionVertical from "@/components/listMissionVertical.vue";
import statusMissionBtnVue from "@/components/statusMissionBtn.vue";
import DialogScan from "@/components/activity/dialogScan.vue";
import FloatPanel from "@/components/floatPanel.vue";
import { adjustHslBrightness } from "@/config/general-function";
import {
  checkImage,
  getFontColorBasedOnBg,
  getLandingPage,
} from "../../../config/general-function";

export default {
  inject: ["isAppLoading"],
  components: {
    InfiniteLoading,
    listMissionVertical,
    statusMissionBtnVue,
    DialogScan,
    FloatPanel,
  },
  data: () => ({
    data: [],
    group: null,
    model: null,
    dataItems: [],
    statusTextMission: "",
    categorySelect: "all",
    category: [],
    dialogConfirmRedeem: false,
    dialogDeleteFavorite: false,
    item: "",
    next_page_url: "",
    infiniteId: +new Date(),
    copyAlert: false,
    statusMission: "",
    dialogScan: false,
    dialogFloatPanel: false,
    fab: true,
    view: "",
    customHeaderPage: "mission",
    customHeader: {
      isUseCustomHeader: false,
      isUseTitle: true,
      image: "",
      titleColor: "#ffffff",
    },
    mission_status: null,
    showList: true,
    previousRouteName: null,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
    });
  },
  async created() {
    this.mission_status = parseInt(this.$route.params.status);
    this.getStatusSummary();
    this.getParamStatus();

    this.getCategory();
    // ========== ========== ========== ==========
    if (this.site?.page_header_cover[this.customHeaderPage]) {
      this.customHeader.isUseCustomHeader =
        this.site?.page_header_cover[
          this.customHeaderPage
        ].is_use_custom_header;
      this.customHeader.isUseTitle =
        this.site?.page_header_cover[this.customHeaderPage].is_use_title;
      const page_header_cover_image =
        this.site?.page_header_cover[this.customHeaderPage].image;
      const _check_image = await checkImage(page_header_cover_image);
      this.customHeader.image = _check_image ? page_header_cover_image : null;
      this.customHeader.titleColor = "#ffffff";
      if (this.customHeader.isUseCustomHeader) {
        this.customHeader.titleColor =
          this.site?.page_header_cover[this.customHeaderPage].title_color ||
          "#ffffff";
      }
    }
  },
  methods: {
    redirectTo() {
      if (this.previousRouteName) {
        this.$router.go(-1);
      } else {
        let listRouteName = [];
        if (
          Array.isArray(this.site?.bottom_nav_bar?.menu) &&
          this.site?.bottom_nav_bar?.menu?.length > 0
        ) {
          const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
            (x) => x.route_allow
          );
          for (let item of listRouteAllow) {
            listRouteName = [...listRouteName, ...item];
          }
        }
        if (listRouteName.length > 0) {
          this.$router.push({ name: listRouteName[0] });
        } else {
          const landing_page = getLandingPage();
          const targetRoute = this.$router.resolve({
            name: landing_page,
          });
          window.location.href = targetRoute.href;
        }
      }
    },
    setBackgoundBox() {
      const _color = this.site.color || "#00000";
      const darken = adjustHslBrightness(_color, -20);
      let _style = `linear-gradient(120deg, ${_color}, ${darken})`;
      if (this.customHeader.isUseCustomHeader && this.customHeader.image) {
        _style = `url("${this.customHeader.image}") center / cover no-repeat`;
      }
      return _style;
    },
    checkTitleShadow() {
      let shadow = "rgb(224 224 224) 2px 1px 1px";
      const color = getFontColorBasedOnBg(this.customHeader.titleColor, "bw");
      if (color == "#000000") {
        shadow = "rgb(66, 68, 90) 2px 1px 1px";
      }
      return shadow;
    },
    setBorderRadiusBox() {
      let _style = `0px 0px 25px 25px`;
      if (this.customHeader.isUseCustomHeader && this.customHeader.image) {
        _style = `0px !important`;
      }
      return _style;
    },
    setTextCategory(param) {
      let label = param.label;
      const category = param.category;
      if (category == "all") {
        label = this.$t("categoryAll");
      } else if (category == "recommend") {
        label = this.$t("categoryRecommend");
      }
      return label;
    },
    updateViewType(val) {
      if (val == 0) {
        this.view = "individual";
      } else {
        this.view = "group";
      }
      this.dataItems = [];
      this.next_page_url = "";
      this.infiniteId++;
    },
    getCategory() {
      Axios.get("mission/listMissionCategory").then(({ data }) => {
        if (data.status == "success") {
          this.category = data.data || [];
          this.category.unshift({
            icon: "order-bool-ascending",
            label: this.$t("categoryAll"),
            category: "all",
          });
        }
      });
    },
    goToMailBox() {
      setTimeout(() => {
        this.$router.push({ name: "mail-box" });
      }, 500);
    },
    openDialogScan() {
      this.dialogScan = true;
    },
    handleScanSuccess(param) {
      const mission_type = param.mission_type;
      const employee_mission = param.employee_mission;
      if (mission_type == "quest-tracking") {
        this.$router.push({
          name: "my-mission-detail",
          params: { id: employee_mission.id },
        });
        return;
      }
    },
    getParamStatus() {
      const status = this.mission_status;
      switch (status) {
        case 0:
          this.statusTextMission = "activityStatusJoin";
          break;
        case 1:
          this.statusTextMission = "activityStatusWait";
          break;
        case 2:
          this.statusTextMission = "activityStatusSuccess";
          break;
        case 3:
          this.statusTextMission = "activityStatusReject";
          break;

        default:
          break;
      }
    },
    getStatusText(status) {
      switch (status) {
        case 0:
          return "activityStatusJoin";
        case 1:
          return "activityStatusWait";
        case 2:
          return "activityStatusSuccess";
        case 3:
          return "activityStatusReject";
        default:
          break;
      }
    },
    gotoMissionFilter(item) {
      this.isAppLoading(true);
      this.statusTextMission = this.getStatusText(
        parseInt(item.mission_status)
      );
      if (item.mission_status == "all") {
        this.$router.push({
          name: "mission",
        });
      } else {
        const curStatus = parseInt(this.$route.params.status);
        if (curStatus == item.mission_status) {
          this.isAppLoading(false);
          return;
        }
        this.$router.push({
          name: "my-mission",
          params: { status: item.mission_status },
        });
        this.mission_status = item.mission_status;
        this.dataItems = [];
        this.next_page_url = "";
        this.infiniteId += 1;
        this.showList = false;
        setTimeout(() => {
          this.showList = true;
        }, 100);
      }
    },
    getStatusSummary() {
      Axios.get("mission/getMissionStatusSummary")
        .then(({ data }) => {
          if (data.status == "success") {
            this.statusMission = data.data;
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err.response.data.message,
            showConfirmButton: false,
            timer: 3000,
          });
          this.$router.push({
            name: "mission",
          });
        });
    },
    infiniteHandler($state) {
      Axios.get("mission/listMyMission", {
        params: {
          category: this.categorySelect,
          status: this.mission_status,
          view: this.view,
          cursor: this.next_page_url,
        },
      })
        .then(({ data }) => {
          if (data.data.data.length) {
            let has_more = data.data.has_more;
            this.dataItems = this.dataItems.concat(data.data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    initialize(cate) {
      this.isAppLoading(true);
      this.dataItems = [];
      this.next_page_url = "";
      this.infiniteId += 1;
      this.categorySelect = cate ? cate.category : "all";
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    inBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      const curRouteName = this.$router.currentRoute.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && listRouteName.includes(curRouteName)) {
        check = true;
      }
      return check;
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    checkFloatPanel() {
      let check = false;
      if (this.site.is_use_float_panel) {
        const float_panel_main_menu = this.site.float_panel_main?.menu || [];
        const float_panel_extend_menu =
          this.site.float_panel_extend?.menu || [];
        const model_main_all_open = float_panel_main_menu.find((x) => x.show);
        const model_extend_all_open = float_panel_extend_menu.find(
          (x) => x.show
        );
        if (model_main_all_open || model_extend_all_open) {
          check = true;
        }
      }
      return check;
    },
  },
  filters: {},
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@900&display=swap");

::v-deep .v-btn__content {
  display: flex;
  flex-direction: column;
}
::v-deep .v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}
::v-deep .v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}
::v-deep .v-slide-group__content {
  justify-content: center !important;
}
.bar-header {
  height: 150px;
  border-bottom-left-radius: 25px !important;
  font-size: 14px;
  border-bottom-right-radius: 25px !important;
}
.title-mission {
  line-height: 1.3;
}
.rowActive {
  position: relative;
}
.expire-date {
  line-height: 0.3;
  position: absolute;
  bottom: 0px;
}
.fab-container {
  position: fixed;
  bottom: 16px;
  right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 1;
}

.custom-slide-btn {
  background-color: #ffffff !important;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.2s ease-in-out;
}

.custom-slide-btn:hover {
  background-color: #f5f5f5 !important;
  transform: scale(1.08);
}

.custom-slide-btn .v-icon {
  color: #333333 !important;
}
</style>


<style scoped>
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
</style>